import { lazy } from "react";
import { ScreenLoader } from "../utils/ScreenLoader";
import { AuthGuard } from "../utils/AuthGuard";
import { Outlet } from "react-router";

// Distributor
const DistributorProvider = ScreenLoader(
  lazy(() => import("../screens/distributor-screen/DistributorProvider")),
);

export const DistribustorRoute = () => ({
  path: "distributor",
  element: (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  ),
  children: [{ path: "providers", element: <DistributorProvider /> }],
});
